module.exports = __webpack_public_path__ + "Simple-Line-Icons.ttf";


//////////////////
// WEBPACK FOOTER
// ./~/simple-line-icons/fonts/Simple-Line-Icons.ttf?v=2.4.0
// module id = 1244
// module chunks = 8